import React from 'react';

import {gt} from 'app/utils/i18n';

import {RenderActionTimestampDocuments} from './render-action-timestamp-documents';
import {RenderDocumentInstance} from './render-document-taskinstance';
import {RenderListDocuments} from './render-list-documents';
import {RenderMostVisitedDocuments} from './render-most-visited-documents';
import {RenderTasksAssignedSummary} from './render-tasks-assigned-summary';
import {RenderTeamSignoffSummaryDocuments} from './render-team-signoff-summary-documents';
import {RenderTeammateRecognitionSummary} from './render-teammates-recognition-summary';
import {RenderTeammateTeamSummary} from './render-teammates-team-summary';
import {RenderTeamSignoffTotals} from './render-teammates-team-totals';

import type {ReportResultSerializedType} from 'sweet-types';

export const renderers: {
  [slug: string]: (result: ReportResultSerializedType<any>) => JSX.Element;
} = {
  'list-documents': (result) => <RenderListDocuments result={result} />,
  'most-visited-documents': (result) => (
    <RenderMostVisitedDocuments result={result} />
  ),
  'newly-created-documents': (result) => (
    <RenderActionTimestampDocuments
      result={result}
      timestampLabel={gt('Created at')}
      memberLabel={gt('Author')}
    />
  ),

  'newly-approved-documents': (result) => (
    <RenderActionTimestampDocuments
      result={result}
      timestampLabel={gt('Approved at')}
      memberLabel={gt('Last author')}
    />
  ),

  'missing-signoffs': (result) => (
    <RenderActionTimestampDocuments
      result={result}
      timestampLabel={gt('Sign off Requested')}
      memberLabel={gt('Team Member')}
    />
  ),

  'signed-signoffs': (result) => (
    <RenderActionTimestampDocuments
      result={result}
      timestampLabel={gt('Signed')}
      enableVersion={true}
      memberLabel={gt('Team Member')}
    />
  ),

  'signoff-per-team-summary': (result) => (
    <RenderTeamSignoffSummaryDocuments
      result={result}
      timestampLabel={gt('Last Request Sent At')}
      memberLabel={gt('Team')}
    />
  ),

  'signoff-per-team-totals': (result) => (
    <RenderTeamSignoffTotals
      result={result}
      timestampLabel={gt('Last Request Sent At')}
      memberLabel={gt('Team')}
    />
  ),

  'tasks-assigned-summary': (result) => (
    <RenderTasksAssignedSummary result={result} />
  ),

  'teammates-team-summary': (result) => (
    <RenderTeammateTeamSummary result={result} />
  ),
  'teammates-recognition-summary': (result) => (
    <RenderTeammateRecognitionSummary result={result} />
  ),
  'document-taskinstance': (result) => (
    <RenderDocumentInstance result={result} />
  ),
};
